/**
 * The avatar stores its data in block attributes only. All frontend markup is
 * produced by the parent Avatar Group's render.php, so the child saves nothing.
 */
export default function Save() {
  return null;
}
